import { Component } from '@angular/core';

@Component({
    templateUrl: './explore-search-page.component.html'
})
export class ExploreSearchPageComponent {}
